import "core-js/modules/es.array.includes";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
var VALID_SPINNER_TYPES = ["secondary", "highlight"];

function LoadingSpinner(_ref) {
  var _classnames;

  var type = _ref.type,
      inline = _ref.inline;
  var loadingClassNames = classnames("loading-square", (_classnames = {}, _defineProperty(_classnames, "loading-square--".concat(type), VALID_SPINNER_TYPES.includes(type)), _defineProperty(_classnames, "loading-square--inline", inline), _classnames));
  return React.createElement("div", {
    className: loadingClassNames,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, React.createElement("div", {
    className: "loading-square__lr"
  }), React.createElement("div", {
    className: "loading-square__tb"
  }));
}

export default LoadingSpinner;
LoadingSpinner.propTypes = {
  type: PropTypes.oneOf(VALID_SPINNER_TYPES),
  inline: PropTypes.bool
};
LoadingSpinner.defaultProps = {
  inline: false
};